<template>
  <div v-b-toggle.custom-collapse class="border rounded py-2 px-3">
    <div
      class="custom-collapse d-flex justify-content-between align-items-center flex-nowrap"
      :class="headerContainerClass"
    >
      <slot class="font-weight-bold" name="header"></slot>

      <i
        class="fa fa-angle-left font-weight-bold"
        :class="isCollapseOpened ? 'rotate-open' : 'rotate-close'"
      ></i>
    </div>
    <b-collapse
      ref="custom-collapse"
      id="custom-collapse"
      class="mt-3"
      :class="collapseClass"
      @show="isCollapseOpened = true"
      @hide="isCollapseOpened = false"
    >
      <slot></slot>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: ["collapseClass", "headerContainerClass"],
  data() {
    return {
      isCollapseOpened: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.custom-collapse > i.rotate-open {
  transition: transform 0.3s;
  transform: rotate(-90deg);
}

.custom-collapse > i.rotate-close {
  transition: transform 0.3s;
  transform: rotate(0deg);
}
</style>
